import { createFileRoute } from '@tanstack/react-router';

import { ListingRedirect } from '@/features/services/listing-redirect';

/** An old worker link: the worker's listing is now their person page (`/p/{slug}`). */
export const Route = createFileRoute('/_app/marketplace/workers/$workerId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { workerId } = Route.useParams();
  return <ListingRedirect listingId={workerId} />;
}
